import { baseBackendUrl } from "../shared/constants";
import {message} from "antd";

export async function fetchProfile(token) {
    try {
        const response = await fetch(`${baseBackendUrl}/user/profile`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            },
        });
        if (!response.ok) {
            throw new Error("Ошибка загрузки профиля");
        }
        return await response.json();
    } catch (error) {
        console.error("Ошибка загрузки профиля:", error);
        throw new Error("Ошибка загрузки профиля");
    }
}

export async function updateAvatar(file, token) {
    const formData = new FormData();
    formData.append("avatar", file);
    try {
        const response = await fetch(`${baseBackendUrl}/user/profile/avatar`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        });
        const result = await response.json();
        if (!response.ok) {
            throw new Error(result.error || "Ошибка обновления аватара");
        }
        return result;
    } catch (error) {
        console.error("Ошибка обновления аватара:", error);
        throw new Error(error.message || "Ошибка обновления аватара");
    }
}

export async function updateProfile(data, token) {
    try {
        const response = await fetch(`${baseBackendUrl}/user/profile`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(data),
        });
        const result = await response.json();
        if (!response.ok) {
            throw new Error(result.error || "Ошибка обновления профиля");
        }
        return result;
    } catch (error) {
        console.error("Ошибка обновления профиля:", error);
        throw new Error(error.message || "Ошибка обновления профиля");
    }
}

export async function loadUsers() {
    const token = localStorage.getItem("token");
    const usersResponse = await fetch(`${baseBackendUrl}/admin-tools`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (!usersResponse.ok) {
        throw new Error("Ошибка при загрузке данных");
    }
    const usersData = await usersResponse.json();
    return usersData;
}

export async function loadGroups() {
    const token = localStorage.getItem("token");
    const groupsResponse = await fetch(`${baseBackendUrl}/teams`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
    if(!groupsResponse.ok) {
        throw new Error("Ошибка при загрузке данных");
    }
    const groupsData = await groupsResponse.json();
    return groupsData;
}

export async function deleteUserData(id){
    const token = localStorage.getItem("token");
    const response = await fetch(`${baseBackendUrl}/admin-tools/${id}`, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
    });
    if (!response.ok) {
        throw new Error("Ошибка при удалении пользователя");
    }
}

export async function updateUserData(id, updatedUser) {
    const token = localStorage.getItem("token");
    const response = await fetch(`${baseBackendUrl}/admin-tools/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(updatedUser),
    });
    if (!response.ok) {
        throw new Error("Ошибка при обновлении пользователя");
    }
}

export async function updateUserGroupData(id, newGroup) {
    const token = localStorage.getItem("token");
    const response = await fetch(`${baseBackendUrl}/admin-tools/${id}/codegroup`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ newGroup }),
    });
    if (!response.ok) {
        throw new Error("Ошибка при изменении группы");
    }
}

export async function resetUserPassword(id, newPassword){
    const token = localStorage.getItem("token");
    const response = await fetch(`${baseBackendUrl}/admin-tools/${id}/reset-password`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ newPassword }),
    });
    if (!response.ok) {
        throw new Error("Ошибка при изменении пароля");
    }
    message.success("Пароль успешно изменен!");
}